module.exports = __webpack_public_path__ + "static/media/smith-nephew2.423350ed.png";